import * as React from 'react';
import type { EntityType } from '@modules/build-hub-comment/types';

export interface Candidate {
    id: string;
    label: string;
    type: EntityType;
}

interface Props {
    query: string;
    candidates: Candidate[];
    highlightIndex: number; // 👈 new
    onSelect: (candidate: Candidate) => void;
    onCancel: () => void;
}

export function CommentAutoComplete({
    candidates,
    highlightIndex,
    onSelect,
}: Props) {
    if (candidates.length === 0) return null;

    return (
        <div className="absolute z-10 mt-1 w-64 rounded border bg-white shadow">
            {candidates.map((c, i) => {
                const isActive = i === highlightIndex;
                return (
                    <div
                        key={`${c.type}:${c.id}`}
                        className={`cursor-pointer px-3 py-1 ${
                            isActive
                                ? 'bg-blue-100 text-blue-900'
                                : 'hover:bg-gray-100'
                        }`}
                        onClick={() => onSelect(c)}
                        tabIndex={0}
                    >
                        <span className={c.type === 'user' ? 'underline' : ''}>
                            {c.label}
                        </span>{' '}
                        <small
                            className={
                                isActive ? 'text-blue-700' : 'text-gray-400'
                            }
                        >
                            ({c.type})
                        </small>
                    </div>
                );
            })}
        </div>
    );
}
